import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

const BY_ADMIN = 'Due to a violation of our terms & conditions, this job has been removed from our platform.'
const BY_CUSTOMER = 'This Full-time Job was removed by the customer.'

export default class VacancyUnavailableChatMessage extends AbstractChatMessage {
  constructor(data: LX.VacancyUnavailableChatMessage) {
    super(data)
    this.body = data.body.is_admin_unpublished || data.body.is_admin_removed ? BY_ADMIN : BY_CUSTOMER
  }

  static fromServer(data: LX.VacancyUnavailableChatMessage) {
    return new VacancyUnavailableChatMessage(data)
  }
}
